import { ErrorDisplayPopperView } from "./error-display-popper-view";
import { useErrorDisplayPopper } from "./use-error-display-popper";

export const ErrorDisplayPopper = () => {
  const logic = useErrorDisplayPopper();
  return <ErrorDisplayPopperView {...logic} />;
};
